// NO formatMoney function - using original display logic

document.addEventListener("DOMContentLoaded", function () {
    console.log("✅ Bulk Order Table Loaded (Pill & Dropdown Update)");

    // Find the section element - needed to read settings
    const bulkOrderTable = document.querySelector(".bulk-order-table[data-section-id]");
    if (!bulkOrderTable) {
        console.error("❌ Bulk Order Table section with data-section-id not found! Check Liquid.");
        return;
    }

    // --- Get Section Settings ---
    const sectionId = bulkOrderTable.dataset.sectionId;
    const isCustomizationEnabled = bulkOrderTable.dataset.enableCustomization === 'true';
    const isDesignEnabled      = bulkOrderTable.dataset.enableDesign       === 'true';
    console.log(`   Section ${sectionId} Settings - Customization: ${isCustomizationEnabled}, Design: ${isDesignEnabled}`);

    // --- Select Elements Conditionally ---
    const customizationInput  = isCustomizationEnabled ? document.getElementById(`bulk-custom-text-${sectionId}`) : null;
    const selectedDesignInput = isDesignEnabled      ? document.getElementById(`selected-design-${sectionId}`)       : null;
    const dropdown            = document.getElementById(`design-dropdown-${sectionId}`)                   || null;
    const designPills         = bulkOrderTable.querySelectorAll('.design-pill')                           || [];

    // --- Log presence of conditional elements ---
    if (isCustomizationEnabled && !customizationInput) {
        console.error(`❌ Customization enabled, but input #bulk-custom-text-${sectionId} not found!`);
    }
    if (isDesignEnabled && !selectedDesignInput) {
        console.error(`❌ Design selection enabled, but input #selected-design-${sectionId} not found!`);
    }
    if (isDesignEnabled && !dropdown) {
        console.warn(`🟡 Design dropdown #design-dropdown-${sectionId} not found; mobile fallback may be missing.`);
    }

    // --- Sync Pill → Hidden Input & Dropdown ---
    function handleSelection(event) {
        const target = event.target.closest('.design-pill');
        if (!target) return;
        const val = target.dataset.design;
        // Deselect all pills
        designPills.forEach(p => p.classList.remove('selected'));
        // Select clicked
        target.classList.add('selected');
        // Update hidden input
        if (selectedDesignInput) selectedDesignInput.value = val;
        // Sync dropdown
        if (dropdown) dropdown.value = val;
    }
    designPills.forEach(pill => {
        pill.addEventListener('click', handleSelection);
        pill.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleSelection(event);
            }
        });
    });

    // --- Sync Dropdown → Pills & Hidden Input ---
    if (dropdown) {
        dropdown.addEventListener('change', () => {
            const val = dropdown.value;
            if (selectedDesignInput) selectedDesignInput.value = val;
            designPills.forEach(pill => {
                pill.classList.toggle('selected', pill.dataset.design === val);
            });
        });
    }

    // --- Sticky Bar Setup ---
    const stickyBar = document.createElement("div");
    stickyBar.classList.add("bulk-order-table__sticky-bar");
    stickyBar.innerHTML = `
     <span class="bulk-order-table__message" style="display: none;"></span>
     <button class="bulk-order-table__add-to-cart" disabled>Add Selected to Cart</button>
    `;
    document.body.appendChild(stickyBar);
    const bulkAddButton = stickyBar.querySelector(".bulk-order-table__add-to-cart");
    const messageSpan   = stickyBar.querySelector(".bulk-order-table__message");

    // --- Update Variant Totals ---
    function updateVariantTotals() {
        let totalItems = 0;
        bulkOrderTable.querySelectorAll(".variant-qty").forEach(input => {
            const qty = parseInt(input.value) || 0;
            const row = input.closest("tr");
            if (!row || row.classList.contains("out-of-stock")) return;
            const priceElem = row.querySelector(".variant-total");
            const price = parseFloat(priceElem.dataset.price) || 0;
            priceElem.textContent = `$${(qty * price).toFixed(2)}`;
            totalItems += qty;
        });
        if (totalItems > 0) {
            stickyBar.classList.add("active"); stickyBar.style.display = "flex";
            bulkAddButton.disabled = false;
        } else {
            stickyBar.classList.remove("active"); stickyBar.style.display = "none";
            bulkAddButton.disabled = true;
        }
    }

    // --- Quantity Buttons ---
    bulkOrderTable.querySelectorAll(".increase-qty, .decrease-qty").forEach(btn => {
        btn.addEventListener("click", function() {
            const vid = this.dataset.variantId;
            const inp = bulkOrderTable.querySelector(`.variant-qty[data-variant-id="${vid}"]`);
            let cur = parseInt(inp.value) || 0;
            const min = parseInt(inp.min) || 0;
            inp.value = this.classList.contains("increase-qty") ? cur+1 : Math.max(cur-1, min);
            updateVariantTotals();
        });
    });
    bulkOrderTable.querySelectorAll(".variant-qty").forEach(input => {
        input.addEventListener("input", updateVariantTotals);
        input.addEventListener("change", updateVariantTotals);
    });

    // --- Add to Cart ---
    bulkAddButton.addEventListener("click", function() {
        let items = [], totalAdded = 0;
        let props = {};
        if (isCustomizationEnabled && customizationInput?.value.trim()) props["Custom Text"] = customizationInput.value.trim();
        if (isDesignEnabled      && selectedDesignInput?.value) props["Design"] = selectedDesignInput.value;
        bulkOrderTable.querySelectorAll(".variant-qty").forEach(input => {
            const qty = parseInt(input.value)||0;
            if (qty>0 && !input.closest("tr").classList.contains("out-of-stock")) {
                let item={id: input.dataset.variantId, quantity: qty};
                if (Object.keys(props).length) item.properties={...props};
                items.push(item); totalAdded+=qty;
            }
        });
        if (!items.length) return showCartMessage("No items selected.", "error");
        fetch("/cart/add.js", {
            method: "POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
            body: JSON.stringify({items})
        })
        .then(res=>res.ok?res.json():res.json().then(err=>{throw err;}))
        .then(data=>{
            console.log("✅ Cart updated:",data);
            showCartMessage(`${totalAdded} products added successfully!`,`success`);
            setTimeout(()=>{
                bulkOrderTable.querySelectorAll(".variant-qty").forEach(inp=>{ if(!inp.closest("tr").classList.contains("out-of-stock")) inp.value="0"; });
                customizationInput&&(customizationInput.value="");
                selectedDesignInput&&(selectedDesignInput.value="", designPills.forEach(p=>p.classList.remove('selected')));
                updateVariantTotals();
            },3000);
        })
        .catch(err=>{
            console.error("🛑 Error:",err);
            showCartMessage(err.description||err.message||"Something went wrong. Try again!",`error`);
        });
    });

    // --- Show Cart Message ---
    function showCartMessage(msg, type) {
        bulkAddButton.style.display = "none";
        messageSpan.textContent = msg; messageSpan.style.display = "block";
        stickyBar.classList.remove("success","error"); stickyBar.classList.add(type);
        stickyBar.style.display = "flex";
        setTimeout(()=>{
            stickyBar.classList.remove("success","error");
            bulkAddButton.style.display = "block"; messageSpan.style.display = "none";
            updateVariantTotals();
        },3000);
    }

    // --- Initial Calculation ---
    updateVariantTotals();
});
